import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Isn’t all of this free on YouTube already?',
  a: 'The drills are. What’s not free is a whole season already planned, sequenced and timed for you — so you’re not spending Sunday night assembling practices from scattered videos. You’re not paying for drills, you’re paying to never build a practice from scratch again.'
}, {
  q: 'I’ve never coached before. Is this too advanced for me?',
  a: 'It’s built for exactly that. Volume 01 gives you the practice engine and your first weeks step by step, the Quick-Start Guide gets you ready in ten minutes, and the Confidence Scripts give you the exact words for day one, explaining a drill, and the post-game talk.'
}, {
  q: 'Will it fit the age and level of my team?',
  a: 'Yes. The Age & Level Cheat Sheet covers 5-6, 7-8, 9-10, 11-12 and 13+ — what to emphasize, which level to run by default, and what to skip — so the same pack works whether you’ve got T-ballers or a travel team.'
}, {
  q: 'I don’t have time to read a 300-page book. Do I have to?',
  a: 'No. You don’t read it cover to cover — you open it to today’s practice and run that one sheet. The Pick-My-Practice flowchart points you straight to the right one in about thirty seconds.'
}, {
  q: 'Is it printable or digital only?',
  a: 'Digital PDFs, laid out for printing. Most coaches print the practice sheet for the day and keep it on a clipboard at the field.'
}, {
  q: 'What about safety — pitch counts and kids’ arms?',
  a: 'Arm care is built in: Volume 05 includes pitch-count guardrails and simple, safe pitching and catching basics. It’s a coaching resource, not medical advice — always follow your league’s rules and keep a parent or guardian in the loop.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-ice text-ink" data-id="element-71" data-mp="1pq4i2lbuqcwx">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-72" data-mp="1po1gr5590xcw">
        <div className="text-center" data-id="element-73" data-mp="1ks2ylzaikbkx">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-74" data-mp="1koypqom3srnx">
            Before you buy
          </p>
          <h2 id="faq-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-75" data-mp="2dfgr9l76ikz8">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-76" data-mp="23g7xotg878de">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-xl border border-ice-dark bg-white" data-id="element-77" data-mp="1zia6xm6t4e7w" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-deep" data-id="element-78" data-mp="nzpl949vsmhl">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-79" data-mp="3dgtycxm9ii3y" /> : <PlusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-80" data-mp="3nc5d3fxo7pbp" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-81" data-mp="6moelwtx9kv">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}